<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">areaOfStudyImport </label>
          <div class="col-sm-3">
            <div>
              <input
                class=""
                type="file"
                ref="file"
                accept="xls/*"
                @change="handleFileUpload()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";
import axios from "axios"

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1,
    };
  },
  created: function() {

  },
  methods: {
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      
      let formData = new FormData();

      /*
                Add the form data we need to submit
            */
      formData.append("xlsFile", this.file);
      formData.append('session', this.$store.state.userInfo.session);
      formData.append('userId', this.$store.state.userInfo.systemUserId);
      formData.append('lang', "en_US")
      /*
          Make the request to the POST /single-file URL
        */
      axios
        .post(this.importCourseQrAreaOfStudy, formData)
        .then(data => {
          if (data.data.errorCode === 0) {
            this.$toastr.s("Import success");
          }else{
            var that = this;
            this.$store.commit("setwarning", {
                string: data.data.errorMessage,
                boolean: true,
                button: [{
                  name:this.$i18n.t("message.Cancel"),
                  callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
                  }
                }]
            })
          }
          this.$refs.file.value = "";
        })
        .catch((e) => {
          this.$toastr.w("Time out, you can check status later","Warning");
          this.$refs.file.value = "";
        });
    },
  },
  mounted() {
  },
};
</script>